// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"_6s7POvpcG-dHi+cNduEf5Q=="};